<template>
  <v-container class="pt-10 pb-16 page-privacy">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <h1 class="page-title mb-4">PRIVACY POLICY</h1>

        <section>
          <h3>1. INTRODUCTION</h3>
          <p>
            Gigvoc Technologies Private Limited ("Gigvoc," "we," "us") is committed to protecting the privacy of our users ("Data Principals"). This policy outlines our practices regarding the collection, use, and disclosure of digital personal data in compliance with the Digital Personal Data Protection (DPDP) Act, 2023.
          </p>
        </section>

        <section>
          <h3>2. DATA WE COLLECT (ITEMIZED)</h3>
          <p>Under the DPDP Act, we only collect data that is necessary for the specified purpose of providing aggregator services:</p>
          <ul>
            <li><strong>Identity Data:</strong> Name, age (to verify adulthood), and gender.</li>
            <li><strong>Contact Data:</strong> Mobile number (verified via OTP) and email address.</li>
            <li><strong>Location Data:</strong> Real-time GPS coordinates to match you with a Service Partner and for the Partner to reach your doorstep.</li>
            <li><strong>Service Data:</strong> Photos of the repair area, voice notes describing the issue, and service history.</li>
            <li><strong>Transaction Data:</strong> UPI IDs or payment status (processed through authorized gateways like Razorpay/PhonePe). We do not store your bank passwords or full card numbers.</li>
          </ul>
        </section>

        <section>
          <h3>3. PURPOSE OF PROCESSING</h3>
          <p>Your data is processed based on your explicit consent for the following:</p>
          <ul>
            <li>Connecting you with a Service Partner for on-site inspection.</li>
            <li>Generating "Indicative Price Estimates" for your specific locality.</li>
            <li>Ensuring safety through partner verification and in-app tracking.</li>
            <li>Facilitating GST-compliant invoicing and digital payments.</li>
          </ul>
        </section>

        <section>
          <h3>4. SHARING WITH SERVICE PARTNERS</h3>
          <p>To fulfill your service request, we share limited data with the independent Service Partner assigned to you:</p>
          <ul>
            <li><strong>Shared Information:</strong> Name, Phone Number, and Precise Service Address.</li>
            <li><strong>Data Minimization:</strong> Partners are legally and contractually bound to use this data only for the specific service booked and must delete your contact info after the work is complete.</li>
          </ul>
        </section>

        <section>
          <h3>5. DATA PRINCIPAL RIGHTS (DPDP ACT 2023)</h3>
          <p>As a user in India, you have the following statutory rights:</p>
          <ul>
            <li><strong>Right to Access:</strong> Request a summary of the personal data we hold about you and a list of third parties (Partners) with whom it was shared.</li>
            <li><strong>Right to Correction & Erasure:</strong> Update inaccurate info or request the deletion of your data once the service is completed (subject to tax law retention).</li>
            <li><strong>Right to Withdraw Consent:</strong> You can withdraw your consent at any time through app settings. Note that withdrawing consent for location data will make it impossible to book a service.</li>
            <li><strong>Right to Nominate:</strong> You can nominate an individual to manage your data rights in the event of your death or incapacity.</li>
          </ul>
        </section>

        <section>
          <h3>6. DATA STORAGE AND SECURITY</h3>
          <ul>
            <li><strong>Localization:</strong> Your personal data is stored on secure servers located within India.</li>
            <li><strong>Retention:</strong> We retain service records for 7 years to comply with Indian Tax (GST) and audit regulations.</li>
            <li><strong>Security:</strong> We use 256-bit encryption and conduct regular security audits as required for "Data Fiduciaries" in India.</li>
          </ul>
        </section>

        <section>
          <h3>7. CHILDREN'S PRIVACY</h3>
          <p>We do not process the data of minors (under 18) without verifiable parental consent. If we discover data from a minor has been collected, it will be deleted immediately.</p>
        </section>

        <section>
          <h3>8. GRIEVANCE REDRESSAL</h3>
          <p>In accordance with the DPDP Act and IT Rules, we have appointed a Grievance Officer to address your concerns.</p>
          <ul>
            <li><strong>Grievance Officer:</strong> [Insert Name]</li>
            <li><strong>Email:</strong> [Insert Email]</li>
            <li><strong>Response Time:</strong> We will acknowledge your grievance within 24 hours and resolve it within 15 days.</li>
          </ul>
        </section>

        <section>
          <h3>Implementation Steps for Gigvoc Technologies </h3>
          <ol>
            <li><strong>Consent Notice:</strong> When a user signs up, the "I Agree" checkbox cannot be pre-ticked. It must be a clear "Affirmative Action" by the user.</li>
            <li><strong>Multilingual Support:</strong> The DPDP Act suggests that if a user asks for this notice in a regional language (like Malayalam, Hindi, or Tamil), you should provide a translated summary.</li>
            <li><strong>OTP Verification:</strong> Ensure mobile numbers are verified via OTP to comply with the "Accuracy of Data" requirement in the Act.</li>
          </ol>
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PrivacyPolicyIndia",
};
</script>

<style scoped>
.page-title { font-size: 34px; font-weight: 700; }
section { margin-bottom: 28px; }
h3 { font-size: 16px; font-weight: 600; margin-top: 18px; margin-bottom: 6px; }
p, li { font-size: 15px; color: #444; line-height: 1.7; }
ul, ol { padding-left: 20px; }
ol { list-style-type: decimal; }
</style>
